import { GET_LICENSE_ID_START } from '../actionType';

export const licenseIDAction = (id) => ({
    type: GET_LICENSE_ID_START,
    id,
});
